import BossModel from "@/models/BossModel";
import Country from "@/models/Country/Country";
import Address from "@/models/Agent/Address/Address";
import BusinessHour from "@/models/Agent/BusinessHour/BusinessHour";
import Code from "@/models/Agent/Code/Code";
import PassportSelection from "@/models/Agent/PassportSelection/PassportSelection";
import MailNotifier from "@/utils/Services/Agent/Notifiers/MailNotifier";
import TravalcoNotifier from "@/utils/Services/Agent/Notifiers/TravalcoNotifier";
import NoNotifier from "@/utils/Services/Agent/Notifiers/NoNotifier";
import JonviewNotifier from "@/utils/Services/Agent/Notifiers/JonviewNotifier";
import TravelnetImporterNotifier from "@/utils/Services/Agent/Notifiers/TravelnetImporterNotifier.js";

export default class Agent extends BossModel {

    static MAIL_NOTIFY = 1;
    static API_NOTIFY = 2;
    static NO_NOTIFY = 3;
    static JONVIEW_NOTIFY = 4;
    static TRAVELNET_IMPORTER_NOTIFY = 5;

    /**
     *
     * @type {string}
     */
    static apiUrl = 'agent';

    /**
     *
     * @type {string}
     */
    static entity = 'agents';

    static fields() {
		return {
			id: this.number(null).nullable(),
            public_id: this.attr(null).nullable(),
            name: this.attr(null),
            email: this.attr(null),
            contact: this.attr(null),
            country_id: this.number(null).nullable(),
            voucher_informal: this.attr(null),
            voucher_formal: this.attr(null),
            cost: this.attr(null),
            notify_cid: this.number(null),
            auto_notify_email: this.attr(null),
            is_active: this.boolean(1),
            is_agent_reference_required: this.boolean(0),
            timezone: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            afas_verbation_code: this.attr(null),
            afas_ledger_eid: this.attr(null),
            country: this.belongsTo(Country, 'country_id'),
            codes: this.hasMany(Code, 'agent_id'),
            addresses: this.hasMany(Address, 'agent_id'),
            businessHours: this.hasMany(BusinessHour, 'agent_id'),
            passportSelections: this.hasMany(PassportSelection, 'agent_id'),
        }
	}

    IsMailNotify() {
        return this.notify_cid === Agent.MAIL_NOTIFY;
    }

    IsApiNotify() {
        return this.notify_cid === Agent.API_NOTIFY;
    }

    IsNoNotify() {
        return this.notify_cid === Agent.NO_NOTIFY;
    }

    IsJonviewNotify() {
        return this.notify_cid === Agent.JONVIEW_NOTIFY;
    }

    IsTravelnetImporterNotify() {
        return this.notify_cid === Agent.TRAVELNET_IMPORTER_NOTIFY;
    }

    get notifier() {
        if (this.IsMailNotify()) {
            return new MailNotifier(this);
        }
        if (this.IsApiNotify()) {
            return new TravalcoNotifier(this);
        }
        if (this.IsNoNotify()) {
            return new NoNotifier(this);
        }
        if (this.IsJonviewNotify()) {
            return new JonviewNotifier(this);
        }
        if (this.IsTravelnetImporterNotify()) {
            return new TravelnetImporterNotifier(this);
        }

        throw new Error(`Unknown notifier type: ${this.notify_cid}`);
    }

    /**
     *
     * @param params
     * @returns {PromiseLike<[]> | Promise<[]> | *}
     */
    static search (params = {}) {
        return this.api()
            .filtered(params.filters)
            .get().then( (data) => {
            let agents = [];
            for(let key in data){
                agents.push(new Agent(data[key]));
            }
            return agents;
        });
    }

    sendProducts(proposalId, statuses = {}, send = true) {
        return this.constructor.api()
            .action(`${this.id}/send-products`)
            .update({
                proposal_id: proposalId,
                statuses: statuses,
                send: send
            });
    }

    /**
     *
     * @returns {boolean|*}
     */
    Country() {
        return this.getRelated('country');
    }
}
